<template>
  <div class="addPeople">
    <el-dialog
      :visible.sync="visible"
      :title="dialogTitle"
      width="880px"
      @close="addPeopleClose"
    >
      <div style="display: flex; flex-direction: row">
        <div style="width: 200px; height: 500px">
          <el-tree
            :data="organizatonData"
            @node-click="organizationClick"
            :props="defaultProps"
            node-key="id"
            default-expand-all
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            highlight-current
            icon-class="none"
            ref="tree"
            style="height: 100%; overflow: auto"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span class="imgDiv">
                <img
                  v-if="node.parent.id.toString() === '0'"
                  src="@/assets/organization/organization_root.png"
                  alt=""
                  class="img"
                />
                <img v-else src="@/assets/pImg/dept.svg" alt="" class="img" />
                {{ node.label }}
              </span>
            </span>
          </el-tree>
        </div>
        <div
          style="
            width: 400px;
            height: 500px;
            border-left: 1px solid #ccc;
            border-right: 1px solid #ccc;
            padding: 0 10px;
          "
        >
          <el-row style="margin-bottom: 10px">
            <el-input
              placeholder="输入人员姓名"
              v-model="keyName"
              style="width: 200px; margin-right: 10px"
            ></el-input>
            <el-button type="primary" @click="goToSearch">搜索</el-button>
          </el-row>
          <el-table
            :data="peopleListInner"
            border
            ref="multipleTable"
            style="width: 100%"
            height="450"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              align="center"
              :selectable="checkStatus"
            >
            </el-table-column>
            <el-table-column prop="id" label="NO" align="center" width="80">
            </el-table-column>
            <el-table-column prop="name" label="人员姓名"> </el-table-column>
            <el-table-column prop="sex" label="性别"> </el-table-column>
          </el-table>
        </div>
        <div style="width: 200px; margin-left: 10px; border: 1px solid #ccc">
          <div>
            <div
              style="
                height: 40px;
                border-bottom: 1px solid #ccc;
                padding-top: 5px;
              "
            >
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  line-height: 30px;
                  height: 30px;
                "
              >
                <div style="flex: 1; padding-left: 6px">
                  已选择 ({{ selectPeopleList.length }})
                </div>
                <el-button
                  type="primary"
                  size="small"
                  style="margin-right: 6px"
                  @click="clearPeopleSelect"
                  >清空</el-button
                >
              </div>
            </div>
            <div
              v-for="(item, index) in selectPeopleList"
              :key="'people' + index"
              style="display: flex; flex-direction: row; line-height: 30px"
            >
              <div style="flex: 1; height: 30px; padding-left: 6px">
                {{ item.name }}
              </div>
              <div
                @click="removePeople(index)"
                style="width: 20px; height: 20px; padding-top: 5px"
                class="el-icon-remove"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="foot">
        <el-button @click="addPeopleClose">取 消</el-button>
        <el-button type="primary" @click="addPeopleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrganizationList,
  getDictList,
  deleteStaff,
} from '@/api/pServer/staff';
import TeamGroupApi from '@/api/teamGroup';
export default {
  name: 'AddPeople',
  props: {
    addPeopleVisible: false,
    dialogTitle: '',
    peopleList: [],
    isLimit: false,
  },
  watch: {
    addPeopleVisible(val) {
      if (val) {
        this.selectPeopleList = JSON.parse(JSON.stringify(this.peopleList));
        this.getPeople();
      }
    },
  },
  computed: {
    visible: {
      get() {
        return this.addPeopleVisible;
      },
      set(val) {
        if (!val) {
          this.$emit('closeAddPeopleVisible');
        }
      },
    },
  },
  data() {
    return {
      nowId: '',
      nowLevel: '',
      keyName: '',
      organizatonData: [],
      selectPeopleList: [],
      originSelectList: [],
      peopleListInner: [],
      defaultProps: {
        children: 'childDeptDto',
        label: 'name',
        id: 'id',
        parentId: 'parentId',
      },
    };
  },
  mounted() {
    this.getOrganizationList();
  },
  methods: {
    //名字搜索
    goToSearch() {
      this.getEmployeeList(this.nowId, this.nowLevel);
    },
    //获取根组织人员
    getPeople() {
      let rootOrg = this.organizatonData[0];
      this.getEmployeeList(rootOrg.id, rootOrg.level);
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(rootOrg.id);
      });
    },
    //点击组织
    organizationClick(data, node) {
      // console.log(node);
      if (node.expanded === true) {
        this.getEmployeeList(data.id, data.level);
      }
    },
    //删除人员刷新
    removePeople(index) {
      this.selectPeopleList.splice(index, 1);
      this.getEmployeeList(this.nowId, this.nowLevel);
    },
    // 获取组织结构接口
    getOrganizationList() {
      getOrganizationList().then((res) => {
        if (res.data.code === 200) {
          this.organizatonData.push(res.data.data);
        }
      });
    },
    //获取人员接口
    getEmployeeList(id, level) {
      this.nowId = id;
      this.nowLevel = level;
      let param = {
        deptId: id,
        level: level,
        name: this.keyName,
        current: 0,
        size: 10000,
      };
      // console.log(param);
      TeamGroupApi.getEmployeeList(param).then((res) => {
        this.peopleListInner = res.data.data.records;
        this.originSelectList = [];
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
          this.peopleListInner.forEach((row) => {
            this.selectPeopleList.forEach((item) => {
              if (item.id === row.id) {
                this.$refs.multipleTable.toggleRowSelection(row, true);
                this.originSelectList.push(row);
              }
            });
          });
        });
      });
    },

    //判断是否禁用.
    checkStatus(row, index) {
      if (
        this.selectPeopleList.some((el) => {
          return el.id === row.id;
        })
      ) {
        return true;
      }
      // console.log("checkStatus");
      // console.log(this.selectPeopleList.length);
      // console.log(this.isLimit);
      if (this.selectPeopleList.length >= 1 && this.isLimit) {
        return false;
      } else {
        return true;
      }

      // if (
      //   this.arr.some((el) => {
      //     return el === row.id;
      //   })
      // ) {
      //   return false;
      // } else {
      //   return true;
      // }
    },

    addPeopleClose() {
      this.visible = false;
    },
    addPeopleSubmit() {
      this.addPeopleClose();
      this.$emit('submitPeople', this.selectPeopleList);
    },
    clearPeopleSelect() {
      this.selectPeopleList = [];
      this.originSelectList = [];
      this.$refs.multipleTable.clearSelection();
    },
    handleSelectionChange(val) {
      let multipleSelection = val;
      let removeList = [];
      if (val.length > 1 && this.isLimit) {
        this.$message({
          message: '组长只能有一位，请重新选择',
          type: 'error',
        });
        return;
      }
      //中间列表选中，右边没有的加入
      multipleSelection.forEach((itemMul) => {
        let have = false;
        this.selectPeopleList.forEach((itemSelect) => {
          if (itemSelect.id === itemMul.id) {
            have = true;
          }
        });
        if (!have) {
          this.selectPeopleList.push(itemMul);
          this.originSelectList.push(itemMul);
        }
      });
      //原始有，中间列表取消选中，右边删除
      this.originSelectList.forEach((itemOrigin) => {
        let have = false;
        multipleSelection.forEach((itemSelect) => {
          if (itemSelect.id === itemOrigin.id) {
            have = true;
          }
        });
        if (!have) {
          removeList.push(itemOrigin.id);
        }
      });
      removeList.forEach((id) => {
        this.selectPeopleList.forEach((item, index) => {
          if (item.id === id) {
            this.selectPeopleList.splice(index, 1);
          }
        });
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.addPeople {
  .foot {
    text-align: center;
    margin-top: 20px;
  }

  .imgDiv {
    height: 60px;
    display: flex;
    align-items: center;
  }

  .img {
    height: 20px;
    width: 20px;
    padding: 10px;
  }
}
</style>
<style>
.el-tree-node__content {
  height: 40px !important;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgba(135, 206, 235, 0.2);
  color: #409eff;
}
</style>
